import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M36.6667 18.4666V19.9999C36.6647 23.594 35.5009 27.0911 33.3489 29.9696C31.197 32.8482 28.1722 34.9541 24.7256 35.9731C21.2791 36.9921 17.5955 36.8698 14.2242 35.6242C10.8528 34.3787 7.97447 32.0768 6.01831 29.0617C4.06215 26.0467 3.13303 22.48 3.3695 18.8938C3.60598 15.3075 4.99539 11.8938 7.33051 9.16173C9.66563 6.42964 12.8214 4.52557 16.327 3.73351C19.8327 2.94145 23.5005 3.30383 26.7834 4.7666",
        stroke: "white",
        "stroke-width": "3.33333",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }),
      _createElementVNode("path", {
        d: "M36.6667 6.6665L20 23.3498L15 18.3498",
        stroke: "white",
        "stroke-width": "3.33333",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })
    ], -1)
  ])))
}
export default { render: render }